import React from 'react';
import { CTAButton } from './CTAButton';
export function Benefits() {
  return <section className="py-8 md:py-16 px-4 bg-dark-900" data-id="element-17">
      <div className="max-w-4xl mx-auto text-center" data-id="element-18">
        <h2 className="text-xl md:text-5xl font-black text-white mb-6 md:mb-8 leading-snug uppercase" data-id="element-19">
          ⚡ ¿CÓMO <span className="text-brand-400" data-id="element-20">FUNCIONA?</span>
        </h2>

        <div className="text-left max-w-2xl mx-auto mb-10 md:mb-16" data-id="element-21">
          <div className="bg-dark-800 p-6 md:p-12 rounded-3xl border-2 border-dark-700 shadow-xl" data-id="element-22">
            <div className="flex flex-col gap-4 md:gap-6 text-base md:text-2xl font-black text-gray-300" data-id="element-23">
              <p className="flex items-center gap-4" data-id="element-24">
                <span className="text-3xl md:text-4xl" data-id="element-25">1️⃣</span> Descargás el
                material
              </p>
              <p className="flex items-center gap-4" data-id="element-26">
                <span className="text-3xl md:text-4xl" data-id="element-27">2️⃣</span> Elegís la
                fórmula que querés fabricar
              </p>
              <p className="flex items-center gap-4" data-id="element-28">
                <span className="text-3xl md:text-4xl" data-id="element-29">3️⃣</span> Comprás los
                ingredientes
              </p>
              <p className="flex items-center gap-4" data-id="element-30">
                <span className="text-3xl md:text-4xl" data-id="element-31">4️⃣</span> Seguís el paso
                a paso
              </p>
              <p className="flex items-center gap-4" data-id="element-32">
                <span className="text-3xl md:text-4xl" data-id="element-33">5️⃣</span> Empezás a
                producir
              </p>
              <p className="flex items-center gap-4 text-brand-400 mt-2" data-id="element-34">
                <span className="text-3xl md:text-4xl" data-id="element-35">6️⃣</span> Vendés tus
                primeros productos
              </p>
            </div>
            <p className="text-center text-xl md:text-2xl font-bold text-white mt-8 pt-6 border-t border-dark-700" data-id="element-36">
              Así de simple.
            </p>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-37">
          <CTAButton data-id="element-38" />
        </div>
      </div>
    </section>;
}